import { render, staticRenderFns } from "./ModalListInput.vue?vue&type=template&id=6b65bfe1&"
import script from "./ModalListInput.vue?vue&type=script&lang=ts&"
export * from "./ModalListInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports